import { render, staticRenderFns } from "./refunds.vue?vue&type=template&id=1124737c&"
import script from "./refunds.vue?vue&type=script&lang=js&"
export * from "./refunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports